import { useMemo } from "react";
import { BarChart, Insights, ShowChart } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import { PageHeader } from "@/components/common/PageHeader";
import { PageHub } from "@/components/common/PageHub";
import { currentFeatures } from "@/configs/Settings";
import { useSessionContext } from "@/contexts/SessionContext";
import { useViewContext } from "@/contexts/ViewContext";

export function InsightsSettings() {
  const navigate = useNavigate();
  const { access } = useSessionContext();
  const { availableRoles } = useViewContext();

  const canAccessClinicalInsights =
    access?.type === "professional" && currentFeatures.defaultApp;

  const canAccessAdministrativeInsights =
    access?.type === "professional" &&
    (availableRoles?.includes("manager") ||
      availableRoles?.includes("owner"));

  const cards = useMemo(() => {
    const items = [];

    if (canAccessClinicalInsights) {
      items.push({
        title: "Insights clínicos",
        icon: <ShowChart fontSize="large" sx={{ color: "primary800.main" }} />,
        description:
          "Análises clínicas de atendimentos, diagnósticos, condutas e protocolos",
        onClick: () => navigate("/clinicalanalysis"),
      });
    }

    if (canAccessAdministrativeInsights) {
      items.push({
        title: "Insights administrativos",
        icon: <BarChart fontSize="large" sx={{ color: "primary800.main" }} />,
        description:
          "Consultas, cobranças, remarcações e panorama da clínica em um só lugar",
        onClick: () => navigate("/stats"),
      });
    }

    return items;
  }, [canAccessAdministrativeInsights, canAccessClinicalInsights, navigate]);

  return (
    <PageHub
      header={
        <PageHeader title="Insights" centered icon={Insights} />
      }
      sections={[{ cards }]}
    />
  );
}
